export default __webpack_public_path__ + "static/media/schedule_desktop.aa7afc97.jpg";